<template>
	<MenuPopup
		ref="popup"
		id="idle-warning-popup"
		:title="languageStore.getString('kiosk_idle_warning_title')"
		:buttons="popupButtons"
		:prevent-overlay-dismiss="true"
		:z-index="2000"
		@toggling-popup="onToggle"
	>
		<div class="idle-warning-body">
			<p class="idle-warning-message">{{ languageStore.getString('kiosk_idle_warning_body') }}</p>
			<div class="idle-warning-countdown">{{ secondsLeft }}</div>
		</div>
	</MenuPopup>
</template>

<script>
import {useLanguageStore} from "@/shared/stores";
import {getNative, isKioskApp} from "@/shared/helpers/webapp";
import MenuPopup from "@/new-menu/components/generic/MenuPopup.vue";

export default {
	name: "IdleWarningPopup",
	components: {MenuPopup},
	setup() {
		const languageStore = useLanguageStore();
		return {languageStore};
	},
	data() {
		return {
			secondsLeft: 0,
			tickHandle: null,
		};
	},
	computed: {
		popupButtons() {
			return [
				{
					text: this.languageStore.getString('kiosk_idle_warning_cta'),
					callback: this.confirmStillHere,
				},
			];
		},
	},
	methods: {
		show(graceSeconds) {
			const grace = parseInt(graceSeconds, 10);
			this.secondsLeft = isNaN(grace) || grace <= 0 ? 10 : grace;
			this.startTicking();
			this.$refs.popup?.toggleStatus(true);
		},
		dismiss() {
			this.stopTicking();
			this.$refs.popup?.toggleStatus(false);
		},
		confirmStillHere() {
			if (isKioskApp()) {
				getNative()?.dismissIdleWarning?.();
			}
			this.dismiss();
		},
		startTicking() {
			this.stopTicking();
			this.tickHandle = setInterval(() => {
				this.secondsLeft = Math.max(0, this.secondsLeft - 1);
				if (this.secondsLeft <= 0) {
					this.stopTicking();
				}
			}, 1000);
		},
		stopTicking() {
			if (this.tickHandle) {
				clearInterval(this.tickHandle);
				this.tickHandle = null;
			}
		},
		onToggle(active) {
			if (!active) {
				this.stopTicking();
			}
		},
	},
	beforeUnmount() {
		this.stopTicking();
	},
};
</script>

<style lang="scss">
#idle-warning-popup .popup-body {
	overflow: visible;
	min-height: 140px;
	align-items: center;
}
</style>

<style lang="scss" scoped>
.idle-warning-body {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	gap: 16px;
}

.idle-warning-message {
	text-align: center;
	font-size: var(--font-size);
	line-height: var(--line-height);
	color: var(--theme-txt2-color);
	margin: 0;
}

.idle-warning-countdown {
	font-size: 64px;
	font-weight: 700;
	line-height: 1;
	color: var(--business-color);
	font-variant-numeric: tabular-nums;
}
</style>
